/* eslint-disable react-hooks/exhaustive-deps */
import { Icon } from "@iconify/react";
import React, { useEffect, useRef, useState } from "react";
import { getSession } from "../../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import {
  getSendersChats,
  sendMessage,
} from "../../../redux/actions/dbactions/chatActions";
export const ChatInbox = ({
  backActionList,
  chatMessages,
  participantName,
  reciverIDS,
  setDefaultpage,
  photoUrl,
}) => {
  const { user_profile_id } = getSession();
  const [message, setMessage] = useState("");

  const dispatch = useDispatch();
  const { send } = useSelector((state) => state.chats);
  const chatBoxRef = useRef(null);

  const handlleSendMessage = () => {
    const payload = {
      msg_rec_userprofile_id: reciverIDS,
      msg_send_userprofile_id: user_profile_id,
      msg_body: message,
    };

    if (message !== "") {
      dispatch(sendMessage(payload));
      setMessage("");
    }
  };

  useEffect(() => {
    chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
  }, [chatMessages]);
  useEffect(() => {
    if (send) {
      dispatch(getSendersChats(reciverIDS));

      setDefaultpage(true);
    }
  }, [dispatch, reciverIDS, send, chatBoxRef]);
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(getSendersChats(reciverIDS));
      setDefaultpage(true);
    }, 60000);
    return () => clearInterval(interval);
  }, [dispatch, reciverIDS]);
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: false, // Use 24-hour format
    };
    return date.toLocaleDateString(undefined, options);
  };
  return (
    <div className="chatBox">
      <div className="open_op">
        <Icon
          icon="formkit:arrowleft"
          onClick={backActionList}
          style={{ fontSize: "12px", cursor: "pointer" }}
        />

        {photoUrl ? (
          <img
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
            src={photoUrl}
            alt=""
          />
        ) : (
          <Icon icon="carbon:user-avatar-filled" className="w-8 h-8" />
        )}

        <div className="details">
          <h6 className="mb-0">{participantName}</h6>
        </div>
      </div>
      <div className="message_box" ref={chatBoxRef}>
        {chatMessages &&
          chatMessages.map((item) => {
            return (
              <div
                key={item.msg_id}
                className={
                  `${item.msg_send_userprofile_id}` === user_profile_id
                    ? "second_box"
                    : "first_box"
                }
              >
                <h5 style={{ fontSize: "14px" }}> {item.msg_body}</h5>
                <div
                  className="xxs:flex-row flex-col"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    className="truncate"
                    style={{
                      fontSize: "11px",
                      display: "block",
                    }}
                  >
                    {formatTimestamp(item.msg_tsp)}
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      display: "block",
                    }}
                  >
                    {item.sender_name}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
      <div className="input_box">
        <input
          type="text"
          onChange={(e) => setMessage(e.target.value)}
          value={message}
          placeholder="Write a message"
        />
        <span onClick={handlleSendMessage}>
          <Icon icon="carbon:send-filled" />
        </span>
      </div>
    </div>
  );
};
